export default __webpack_public_path__ + "static/building-860923_1280-28a9435782286b21b4ee9e212f7ab5a7.png";